import React from "react";
import Menu from "@shared/layout/Menu";
import MyPhysio from "@features/physio/components/MyPhysio";

const routes = [
  {
    path: "/myphysio",
    element: <Menu content={<MyPhysio />} />,
    isProtected: true,
  },
];

export default routes;
